import { makeAutoObservable, runInAction } from 'mobx'
import { openApi } from '../../../helpers/request'
import i from '../../../translations/i'
import { FormEvent } from 'react'
import { notification } from 'antd'
import __select from '../../../helpers/select_entity/__select.controller'

class CPLController {

    pagination = {
        limit: 10,
        page: 1,
        total: 0
    }

    is_system = false

    list: any[] = []
    // Первая загрузка списка: до ответа показываем скелетоны, а не пустое состояние
    loading = false

    item: any = {
        id: 0,
        name: '',
        id_crm: '',
        conditions: [],
        name_encode: null,
        seo_title: null,
        seo_description: null,
        seo_keywords: null,
        exception: true,
        description: null,
        image: null
    }

    selectedList: null|number = null;
    selectedLists: any[] = []

    properties: any = {}

    modalOpened = false
    productsModalSelectedIndex: number = -1
    selectedConditionProducts = []

    image: any = null

    constructor() {
        makeAutoObservable(this)
    }

    getList() {
        let uri = `/custom_list_products?limit=${this.pagination.limit}&page=${this.pagination.page}&is_system=${+ this.is_system}`

        this.loading = true

        openApi('get', uri)
            .then(result => {
                this.list = result.data.map((el: any) => ({...el, key: el.id}))
                this.pagination.total = result.total
            })
            .catch(error => console.log(error.response))
            .finally(() => runInAction(() => this.loading = false))
    }

    setPage(page: number) {
        runInAction(() => this.pagination.page = page)
        this.getList()
    }

    getOne(id: null|number) {
        if(id && id > 0) {
            let uri = `/custom_list_products/${id}`

            openApi('get', uri)
                .then(result => {
                    this.item = result.data
                    console.log(result.data)

                    if(result.data?.conditions) {
                        result.data.conditions.map((el: any, index: number) => {
                            let productIDs: any[] = []
                            let products: any[] = []

                            if(el.type === 'prop') {
                                this.getPropertyValues(el.label)
                            } else if(el.type === 'products') {

                                el.products.map((p: any) => {
                                    productIDs.push({
                                        id: p.product_id,
                                        sorting: p.sorting ?? 500
                                    })
                                    products.push(p.product)
                                })
                            }

                            this.item.conditions[index].products = products
                            this.item.conditions[index].productIDs = productIDs
                        })
                    }
                })
                .catch(error => console.log(error.response))
        }
    }

    deleteOne(listID: number) {
        openApi('delete', `/custom_list_products/${listID}`)
            .then(() => {
                this.getList()
            })
            .catch(error => console.log(error.response))

    }

    save(type: string = 'list') {

        const data = new FormData()

        if(this.item.id > 0) {
            data.append('id', this.item.id)
        }
        if(this.item.id_crm === null) this.item.id_crm = ''

        data.append('name', this.item.name)
        data.append('id_crm', this.item.id_crm)
        if(this.item.name_encode) data.append('name_encode', this.item.name_encode)
        if(this.item.seo_title) data.append('seo_title', this.item.seo_title)
        if(this.item.seo_description) data.append('seo_description', this.item.seo_description)
        if(this.item.seo_keywords) data.append('seo_keywords', this.item.seo_keywords)
        if(this.item.description) data.append('description', this.item.description)
        data.append('exception', this.item.exception ? '1' : '0')

        if(!this.item.image)
            data.append('delete_image', '1')

        if(this.image) data.append('image', this.image)

        if(this.item.conditions.length > 0) {
            this.item.conditions.map((el: any, key: number) => {
                console.log(el)
                if(el.id > 0) {
                    data.append(`conditions[${key}][id]`, el.id)
                }
                if(el.label !== '' && el.label) {
                    data.append(`conditions[${key}][label]`, el.label)
                }
                if(el.description !== '' && el.description !== null && el.description) {
                    data.append(`conditions[${key}][description]`, el.description)
                }
                data.append(`conditions[${key}][type]`, el.type)
                if(el.type === 'products') {
                    el.productIDs.map((product_element: any, index: number) => {
                        if(product_element.id) {
                            data.append(`conditions[${key}][products][${index}][id]`, product_element.id)
                            data.append(`conditions[${key}][products][${index}][sorting]`, product_element.sorting ?? 500)
                        } else {
                            data.append(`conditions[${key}][products][${index}][id]`, product_element)
                        }
                    })
                } else {
                    data.append(`conditions[${key}][value]`, el.value && el.value !== '' ? el.value : __select.select.value)
                }
            })
        } else {
            return notification.error({
                message: i.t('def:errors.error'),
                description: i.t('def:Need to fill Conditions')
            })
        }

        openApi('post', '/custom_list_products', data)
            .then(result => {
                if(type === 'list' && this.item.id === 0) {
                    window.location.href = `/catalog/lists`
                } else {
                    if(this.item.id === 0 || this.item.id === null) {
                        this.item.id = result.data.id
                    }

                    if(type === 'group') {
                        this.selectedList = null
                        this.getList()
                    }

                    notification.success({
                        message: i.t('def:success.success'),
                        description: i.t('def:success.edit')
                    })
                }
            })
            .catch(error => {
                console.log(error.response)
                notification.error({
                    message: i.t('def:errors.error'),
                    description: error.response.data.data.message ?? 'error'
                })
            })
    }

    getPropertyValues(id: number) {
        if(this.properties[id]) return

        openApi('get', `/filters/${id}`)
            .then(result => {
                this.properties[id] = result.data
            })
            .catch(error => console.log(error.response))
    }

    selectList(id: number, multiple: boolean) {
        if(this.selectedLists.findIndex((el: any) => el === id) > -1) {
            this.selectedLists = this.selectedLists.filter((el: any) => el !== id)
        } else {
            if(multiple) {
                let array = this.selectedLists
                array.push(id)
                this.selectedLists = array
            } else {
                this.selectedLists = [id]
            }
        }
    }

    setEditedList(id: number) {
        this.selectedList = id

        if(id > 0) this.getOne(id)
        else {
            this.item = {
                id: 0,
                name: '',
                id_crm: '',
                conditions: [],
                name_encode: null,
                seo_title: null,
                seo_description: null,
                seo_keywords: null,
                exception: true,
                description: null,
                image: null
            }
            this.image = null
        }
    }

    addCondition() {
        this.item.conditions.push({
            id: 0,
            type: 'products',
            label: '',
            value: '',
            products: [],
            productIDs: [],
            category: []
        })
    }

    removeCondition(index: number) {
        this.item.conditions.splice(index, 1)
        if(this.properties?.[index]) delete this.properties[index]
    }

    changeConditionType(type: string, index: number) {
        this.item.conditions[index].type = type
        this.item.conditions[index].label = ''
        this.item.conditions[index].value = ''
    }

    toggleModal(index = -1) {
        if(!this.modalOpened) this.productsModalSelectedIndex = index

        if(this.item.conditions?.[this.productsModalSelectedIndex]?.type === 'products') {
            if(this.modalOpened){
                this.item.conditions[this.productsModalSelectedIndex].productIDs = __select.select.value_array
            } else {
                this.selectedConditionProducts = this.item.conditions[index].products
                __select.select.value_array = this.item.conditions[index].productIDs
            }
        }

        if(this.item.conditions?.[this.productsModalSelectedIndex]?.type === 'category') {
            if(this.modalOpened){
                // Из дерева категорий приходит { value, title }, с бэка после сохранения — { id, name }
                const categoryID = __select.element?.id ?? __select.element?.value ?? ''

                this.item.conditions[this.productsModalSelectedIndex].category = categoryID
                    ? { id: categoryID, name: __select.element.name ?? __select.element.title ?? '' }
                    : []
                this.item.conditions[this.productsModalSelectedIndex].value = categoryID
            } else {
                __select.select.value = this.item.conditions[index].category?.id ?? ''
                __select.setElement(this.item.conditions[index].category ?? [])
            }
        }

        if(this.item.conditions?.[this.productsModalSelectedIndex]?.type === 'type') {
            if(this.modalOpened){
                this.item.conditions[this.productsModalSelectedIndex].value = __select.select.value ?? 0
            } else {
                __select.select.value = this.item.conditions[this.productsModalSelectedIndex].value ?? 0
            }
        }

        if(this.modalOpened) this.productsModalSelectedIndex = index
        this.modalOpened = !this.modalOpened
    }

    changeCharacteristic(id: number, index: number) {
        this.item.conditions[index].label = id
        this.item.conditions[index].value = ''
        this.getPropertyValues(id)
    }

    upload(image: any) {
        this.image = image
        return false
    }
}

export const __cpl = new CPLController()